<app-banner></app-banner>

<!-- About Us, Our Programs, Our Journey, Voices and Get In Touch all sit on the same page background in Figma -->
<div class="bg-surface-section">
  <app-about-us></app-about-us>
  <app-our-programs></app-our-programs>
  <app-our-journey></app-our-journey>
  <app-voices></app-voices>
  <app-get-in-touch></app-get-in-touch>
</div>